module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/auycJi/tc-custom/9781504069953.jpg?1704512084615",
      "alt": "This image is the cover for the book Tight Lies, The Tom Hunter Books"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tight Lies, The Tom Hunter Books\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Behind the refined veneer of professional golf, a sports agent discovers a world of corruption and international criminals: “Hard, fast and really good!” —Lee Child")]), _c('br'), _c('br'), _vm._v("Daniel Ratchet has arrived in Spain, ready to begin his dream job as a golf agent on the professional Tour. Meanwhile, in London, new Tour sponsor Russian Rublex Corporation, with a hidden history of mafia criminality, is pushing through a huge deal with the British government. But things are not what they seem . . ."), _c('br'), _c('br'), _vm._v("With the help of Wallace, a cantankerous old golf coach, Daniel discovers match fixing, fraud, and corruption at the heart of the game. A thorn in the Russians’ side, Daniel is kidnapped before he can expose the truth. So Wallace contacts an old army buddy—who deploys loose cannon Tom Hunter on a mission to save him .  .  ."), _c('br'), _c('br'), _vm._v("This explosive debut novel is an exhilarating action thriller set in the seductive world of professional sports—against a backdrop of political and corporate corruption in a world of brutal violence.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ted Denton\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0